// GRIMSUPPS formula story data — exact text extracted from Instagram carousel pages (assets/pages/<slug>/N.png)
// Scene: { q, paras[], note:{lead,text}, viz:{kind,...} } — viz kinds: stack|flow|compare|chelate|puzzle|crop
window.STORY = {
  magnesium: [
    { q: 'Magnezyumun neden farklı formları var?',
      paras: [
        'Magnezyum tek başına değil, başka bileşiklere bağlanmış şekilde kullanılır.',
        'Bu yüzden etikette sitrat, malat, bisglisinat veya taurat gibi farklı formlar görürsün.',
        'Her formda magnezyuma eşlik eden bileşik farklıdır. Sitratta sitrik asit, malatta malik asit, bisglisinatta glisin, taurat formunda ise taurin bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL MAGNESIUM COMPLEX 4', text: 'formülde sitrat, malat, bisglisinat ve taurat olmak üzere 4 farklı magnezyum formu bulunur.' },
      viz: { kind: 'stack', items: [
        { t: 'SİTRAT', s: 'Sitrik Asit', c: '#3D7A6C' },
        { t: 'MALAT', s: 'Malik Asit', c: '#5A7186' },
        { t: 'BİSGLİSİNAT', s: 'Glisin', c: '#2C4A73' },
        { t: 'TAURAT', s: 'Taurin', c: '#6E7378' }] } },
    { q: 'Elementel magnezyum ne demek?',
      paras: [
        'Elementel magnezyum, vücudun aldığı gerçek magnezyum miktarını ifade eder.',
        'Etiketlerde yazan bileşik miktarı ile elementel magnezyum miktarı aynı olmayabilir.',
        'Bu yüzden karşılaştırma yaparken elementel magnezyum değerine bakmak gerekir.'],
      note: { lead: 'GRIMSUPPS CLINICAL MAGNESIUM COMPLEX 4', text: 'her tablette 200 mg elementel magnezyum bulunur.' },
      viz: { kind: 'flow',
        from: { label: 'BİLEŞİK MİKTARI', crop: { img: 'assets/pages/magnesium/2.png', x: 0.72, y: 0.325, f: 0.30 } },
        to: { label: 'ELEMENTEL MAGNEZYUM', sub: 'GERÇEK MAGNEZYUM MİKTARI', stat: '200 mg' } } },
    { q: 'Magnezyum sitrat ile magnezyum bisglisinat aynı şey mi?',
      paras: [
        'Hayır, ikisi de magnezyum içerir ancak farklı bileşiklerdir.',
        'Sitrat, magnezyumun sitrik asit ile; bisglisinat ise glisin amino asidi ile bağlandığı formdur.',
        'Bu nedenle ürün etiketlerinde farklı magnezyum formları ayrı ayrı belirtilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL MAGNESIUM COMPLEX 4', text: 'formülde hem magnezyum sitrat hem de magnezyum bisglisinat yer alır.' },
      viz: { kind: 'compare',
        a: { title: 'MAGNEZYUM SİTRAT', caption: 'Sitrik Asit ile bağlıdır.', crop: { img: 'assets/pages/magnesium/3.png', x: 0.72, y: 0.27, f: 0.36 } },
        b: { title: 'MAGNEZYUM BİSGLİSİNAT', caption: 'Glisin amino asidi ile bağlıdır.', crop: { img: 'assets/pages/magnesium/3.png', x: 0.68, y: 0.60, f: 0.38 } } } },
    { q: 'Şelatlı magnezyum ne demek?',
      paras: [
        'Şelatlı magnezyum, magnezyumun bir amino asit veya organik bileşik ile bağlanmış formunu ifade eder.',
        'Bu yapıda magnezyum, başka bir bileşik tarafından sarılarak bir kompleks oluşturur.',
        'Magnezyum bisglisinat, şelatlı magnezyum formlarından bir örnektir.'],
      note: { lead: 'GRIMSUPPS CLINICAL MAGNESIUM COMPLEX 4', text: 'formülde bulunan magnezyum bisglisinat, şelatlı magnezyum formlarından biridir.' },
      viz: { kind: 'chelate', center: 'Mg', caption: 'AMİNO ASİT / ORGANİK BİLEŞİK (ŞELAT YAPISI)' } },
    { q: 'Neden bazı magnezyum ürünlerinde tek form, bazılarında ise birden fazla form bulunur?',
      paras: [
        'Magnezyum ürünleri üreticinin formül tercihine göre hazırlanır. Bazı ürünlerde tek bir magnezyum formu kullanılırken, bazı formüllerde birden fazla magnezyum bileşiği bir araya getirilebilir.',
        'Farklı formların birlikte kullanılması, formülün çeşitlendirilmesini sağlar.'],
      note: { lead: 'GRIMSUPPS CLINICAL MAGNESIUM COMPLEX 4', text: 'formülü, 4 farklı magnezyum formunu tek tablette bir araya getirir.' },
      viz: { kind: 'puzzle', items: [
        { t: 'SİTRAT', c: '#3D7A6C' }, { t: 'MALAT', c: '#4A6B8A' },
        { t: 'BİSGLİSİNAT', c: '#2C4A73' }, { t: 'TAURAT', c: '#6E7378' }] } },
    { q: 'Magnesium Complex 4\u2019te hangi bileşenler bulunur?',
      paras: [
        'GRIMSUPPS CLINICAL MAGNESIUM COMPLEX 4\u2019te dört farklı magnezyum formu ve aktif B6 vitamini bir arada bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL MAGNESIUM COMPLEX 4', text: 'Advanced 4-Form Magnesium · 60 tablet.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '1 Tablet', perContainer: '60 Servis', unit: '1 Tablet', rows: [
        { n: 'Magnezyum (Magnesium)', v: '200 mg', brd: '%53,33' },
        { n: 'Magnezyum Sitrat', v: '77,5 mg', sub: true },
        { n: 'Magnezyum Malat', v: '50 mg', sub: true },
        { n: 'Magnezyum Bisglisinat', v: '50 mg', sub: true },
        { n: 'Magnezyum Taurat', v: '22,5 mg', sub: true },
        { n: 'B6 Vitamini (Piridoksal 5-fosfat)', v: '10 mg', brd: '%714,29' }
      ], foot: 'Girintili satırlar, 200 mg elementel magnezyuma katkı sağlayan dört formu gösterir.' } }
  ],
  '5htp': [
    { q: '5-HTP ile serotonin aynı şey mi?',
      paras: [
        'Hayır.',
        '5-HTP ile serotonin aynı madde değildir. 5-HTP, vücutta serotoninin üretim sürecinde yer alan bir ara bileşiktir.'],
      note: { lead: 'GRIMSUPPS CLINICAL 5-HTP', text: 'her serviste 300 mg 5-HTP içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/5htp/1.png', x: 0.63, y: 0.42, f: 0.46 }, caption: 'Serotoninin üretim sürecinde yer alan ara bileşik' } },
    { q: '5-HTP ile triptofan aynı şey mi?',
      paras: [
        'Hayır.',
        'Triptofan bir amino asittir. 5-HTP ise triptofandan sonra gelen farklı bir bileşiktir. İkisi aynı değildir.'],
      note: { lead: 'GRIMSUPPS CLINICAL 5-HTP', text: 'her serviste 300 mg 5-HTP içerir.' },
      viz: { kind: 'path', items: [
        { t: 'TRİPTOFAN', crop: { img: 'assets/pages/5htp/2.png', x: 0.50, y: 0.50, f: 0.27 } },
        { t: '5-HTP', crop: { img: 'assets/pages/5htp/2.png', x: 0.66, y: 0.625, f: 0.27 } },
        { t: 'SEROTONİN', crop: { img: 'assets/pages/5htp/2.png', x: 0.845, y: 0.51, f: 0.25 } }] } },
    { q: '5-HTP doğal mı, sentetik mi?',
      paras: [
        'Grimsupps Clinical 5-HTP\u2019de kullanılan 5-HTP sentetik değil, doğal kaynaklıdır.',
        '5-HTP genellikle Griffonia simplicifolia bitkisinin tohumlarından elde edilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL 5-HTP', text: 'her serviste 300 mg doğal kaynaklı 5-HTP içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/5htp/3.png', x: 0.66, y: 0.44, f: 0.52 }, caption: 'Griffonia simplicifolia tohumları' } },
    { q: 'L-Theanine kafein içerir mi?',
      paras: [
        'Hayır.',
        'L-Theanine bir amino asittir. Çay yapraklarında doğal olarak kafeinle birlikte bulunsa da, iki bileşen aynı madde değildir.',
        'L-Theanine\u2019in kendisi kafein içermez.'],
      note: { lead: 'GRIMSUPPS CLINICAL 5-HTP', text: 'her serviste 200 mg L-Theanine içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/5htp/4.png', x: 0.71, y: 0.53, f: 0.5 }, caption: 'Çay yaprakları — L-Theanine kaynağı' } },
    { q: 'Griffonia nedir?',
      paras: [
        'Griffonia, Batı Afrika\u2019ya özgü Griffonia simplicifolia bitkisinin adıdır.',
        'Bu bitkinin tohumları doğal olarak 5-HTP içerir.',
        'Takviye ürünlerinde kullanılan 5-HTP, bu bitkiden elde edilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL 5-HTP', text: 'her serviste 300 mg 5-HTP içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/5htp/5.png', x: 0.68, y: 0.43, f: 0.54 }, caption: 'Griffonia simplicifolia — Batı Afrika' } },
    { q: 'Sarı kantaron çayı ile ekstresi aynı şey mi?',
      paras: [
        'Hayır.',
        'Bitki çayı, bitkinin sıcak suda demlenmesiyle hazırlanır. Ekstre ise bitkinin belirli bileşenlerinin yoğunlaştırılmasıyla elde edilir. Bu nedenle çay ile ekstre aynı ürün değildir.'],
      note: { lead: 'GRIMSUPPS CLINICAL 5-HTP\u2019DE', text: 'her serviste 200 mg Sarı Kantaron Ekstresi (Hypericum perforatum) bulunur.' },
      viz: { kind: 'compare',
        a: { title: 'BİTKİ ÇAYI', caption: 'Sıcak suda demlenerek hazırlanır.', crop: { img: 'assets/pages/5htp/6.png', x: 0.49, y: 0.615, f: 0.30 } },
        b: { title: 'EKSTRE', caption: 'Belirli bileşenlerin yoğunlaştırılmasıyla elde edilir.', crop: { img: 'assets/pages/5htp/6.png', x: 0.825, y: 0.53, f: 0.30 } } } },
    { q: 'Clinical 5-HTP\u2019de hangi bileşenler bulunur?',
      paras: [
        'GRIMSUPPS CLINICAL 5-HTP\u2019de her serviste 8 farklı bileşen bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL 5-HTP', text: 'Mood & Calm Support · 60 tablet.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '2 Tablet', perContainer: '30 Servis', unit: '2 Tablet', rows: [
        { n: '5-Hidroksitriptofan (5-HTP)', v: '300 mg', brd: '**' },
        { n: 'L-Teanin', v: '200 mg', brd: '**' },
        { n: 'Rodiola Ekstresi', v: '200 mg', brd: '**' },
        { n: 'Mabet Ağacı Ekstresi', v: '200 mg', brd: '**' },
        { n: 'Sarı Kantaron Ekstresi', v: '200 mg', brd: '**' },
        { n: 'Passiflora Ekstresi', v: '200 mg', brd: '**' },
        { n: 'Piperin', v: '10 mg', brd: '**' },
        { n: 'Pridoksal 5-fosfat (P-5-P)', v: '10 mg', brd: '%714,3' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  omega: [
    { q: 'Omega-3 alırken etikette ilk neye bakılmalı?',
      paras: [
        'Sadece balık yağı miktarına bakmak yeterli değildir. Ürünün içerdiği toplam Omega-3 ile EPA ve DHA miktarları da etikette açıkça belirtilmelidir.'],
      note: { lead: 'GRIMSUPPS CLINICAL OMEGA-3', text: 'Balık Yağı: 3000 mg · Toplam Omega-3: 1800 mg · EPA: 1080 mg · DHA: 720 mg' },
      viz: { kind: 'compare', joiner: '+',
        a: { title: 'BALIK YAĞI MİKTARI', caption: 'Tek başına yeterli bilgi vermez.' },
        b: { title: 'EPA + DHA MİKTARI', caption: 'Etikette ayrı ayrı belirtilmelidir.' } } },
    { q: 'Balık yağı ile Omega-3 aynı şey mi?',
      paras: [
        'Balık yağı, Omega-3 yağ asitlerinin doğal kaynaklarından biridir. Ancak her balık yağı aynı miktarda EPA ve DHA içermez. Bu nedenle ürün seçerken toplam Omega-3 ve EPA/DHA değerlerine bakılması önemlidir.'],
      note: { lead: 'GRIMSUPPS CLINICAL OMEGA-3', text: '1800 mg Omega-3 içerir. Bunun 1080 mg\u2019ı EPA, 720 mg\u2019ı DHA\u2019dır.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/omega/2.png', x: 0.63, y: 0.62, f: 0.6 }, caption: 'Balık yağı — Omega-3\u2019ün doğal kaynağı' } },
    { q: 'Softgel neden kullanılır?',
      paras: [
        'Softgel kapsüller, içeriğin ışık ve hava ile temasını azaltarak formülün korunmasına yardımcı olur. Aynı zamanda yutması kolaydır ve pratik kullanım sağlar.'],
      note: { lead: 'GRIMSUPPS CLINICAL OMEGA-3', text: 'Yüksek kaliteli balık yağı, pratik softgel form ile sunulur.' },
      viz: { kind: 'points', crop: { img: 'assets/pages/omega/3.png', x: 0.78, y: 0.48, f: 0.4 }, items: [
        { t: 'KOLAY YUTULUR', s: 'Pürüzsüz yüzeyi sayesinde daha rahat kullanılır.' },
        { t: 'İÇERİĞİ KORUR', s: 'Işık, hava ve nem ile temasını azaltır.' },
        { t: 'PRATİK KULLANIM', s: 'Günlük kullanımda kolaylık sağlar.' }] } },
    { q: 'Trigliserid formu ne demek?',
      paras: [
        'Balık yağları farklı formlarda üretilebilir. Trigliserid formu, doğal balık yağında bulunan yapıya benzer formdur ve birçok premium Omega-3 ürününde tercih edilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL OMEGA-3', text: 'Balık yağı trigliserid formundadır.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/omega/4.png', x: 0.72, y: 0.47, f: 0.52 }, caption: 'Doğal yağ damlasındaki trigliserid yapısı' } },
    { q: 'EPA ile DHA aynı şey mi?',
      paras: [
        'Hayır. EPA ve DHA, Omega-3 ailesine ait iki farklı yağ asididir. Takviye ürünlerinde genellikle birlikte bulunurlar ve içerik tablosunda ayrı ayrı belirtilirler.'],
      note: { lead: 'GRIMSUPPS CLINICAL OMEGA-3', text: 'Her 3 softgelde: EPA 1080 mg · DHA 720 mg içerir.' },
      viz: { kind: 'compare',
        a: { title: 'EPA', caption: 'Eicosapentaenoic Acid — 1080 mg', crop: { img: 'assets/pages/omega/5.png', x: 0.58, y: 0.56, f: 0.34 } },
        b: { title: 'DHA', caption: 'Docosahexaenoic Acid — 720 mg', crop: { img: 'assets/pages/omega/5.png', x: 0.85, y: 0.50, f: 0.34 } } } },
    { q: 'Omega-3 Trigliserid Form — içerik tablosu',
      paras: [
        '3 softgel\u2019lik serviste 3000 mg balık yağından 1800 mg Omega-3 elde edilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL OMEGA-3', text: 'Pure Triglyceride Formula · 90 softgel.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '3 Softgel', perContainer: '30 Servis', unit: '3 Softgel', rows: [
        { n: 'Omega 3', v: '1800 mg', brd: '**' },
        { n: 'Balık Yağı (Trigliserid Form)', v: '3000 mg', brd: '**' },
        { n: 'EPA (Eicosapentaenoic Acid)', v: '1080 mg', brd: '**' },
        { n: 'DHA (Docosahexaenoic Acid)', v: '720 mg', brd: '**' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  lionsmane: [
    { q: 'Aslan yelesi mantarı neden bu ismi almış?',
      paras: [
        'Aslan yelesi mantarı, uzun ve sarkık beyaz dikenimsi yapısı nedeniyle bu ismi almıştır.',
        'Bilimsel adı Hericium erinaceus olan bu mantar, görünümü nedeniyle birçok dilde Lion\u2019s Mane olarak da adlandırılır.'],
      note: { lead: "GRIMSUPPS CLINICAL LION'S MANE", text: 'her serviste 1000 mg Aslan Yelesi Mantarı Ekstresi içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/lionsmane/1.png', x: 0.72, y: 0.42, f: 0.52 }, caption: 'Hericium erinaceus — aslan yelesi mantarı' } },
    { q: 'Ekstre ile mantar tozu arasında ne fark var?',
      paras: [
        'Mantar tozu, kurutulmuş mantarın öğütülmesiyle elde edilir.',
        'Mantar ekstresi ise mantarın belirli bileşenlerinin yoğunlaştırılmasıyla hazırlanır.',
        'Bu nedenle etiketlerde mantar tozu ve mantar ekstresi farklı içerikleri ifade edebilir.'],
      note: { lead: "GRIMSUPPS CLINICAL LION'S MANE", text: 'formülünde mantar tozu yerine 1000 mg Aslan Yelesi Mantarı Ekstresi kullanılmıştır.' },
      viz: { kind: 'compare',
        a: { title: 'MANTAR TOZU', caption: 'Kurutulmuş mantarın öğütülmesiyle elde edilir.', crop: { img: 'assets/pages/lionsmane/2.png', x: 0.75, y: 0.31, f: 0.4 } },
        b: { title: 'MANTAR EKSTRESİ', caption: 'Belirli bileşenlerin yoğunlaştırılmasıyla hazırlanır.', crop: { img: 'assets/pages/lionsmane/2.png', x: 0.74, y: 0.63, f: 0.4 } } } },
    { q: "Aslan yelesi mantarı hangi ülkelerde yetişir?",
      paras: [
        'Aslan yelesi mantarı doğal olarak başta Çin, Japonya, Kore ve Kuzey Amerika olmak üzere birçok bölgede yetişir.',
        'Günümüzde kontrollü üretim tesislerinde de yetiştirilmektedir.'],
      note: { lead: "GRIMSUPPS CLINICAL LION'S MANE", text: "formülünün ana bileşeni 1000 mg Aslan Yelesi Mantarı Ekstresi'dir." },
      viz: { kind: 'pins', items: ['KUZEY AMERİKA', 'ÇİN', 'JAPONYA', 'KORE'] } },
    { q: 'N-Asetil L-Tirozin ile L-Tirozin aynı şey mi?',
      paras: [
        'Hayır. N-Asetil L-Tirozin (NALT), L-Tirozinin asetillenmiş formudur.',
        'Takviye ürünlerinde her iki form da kullanılabilir ve etiketlerde hangi formun tercih edildiği ayrıca belirtilir.'],
      note: { lead: "GRIMSUPPS CLINICAL LION'S MANE", text: 'formülünde 200 mg N-Asetil L-Tirozin (NALT) bulunur.' },
      viz: { kind: 'compare',
        a: { title: 'L-TİROZİN', caption: 'Amino asidin serbest formu.', crop: { img: 'assets/pages/lionsmane/4.png', x: 0.745, y: 0.335, f: 0.42 } },
        b: { title: 'N-ASETİL L-TİROZİN (NALT)', caption: 'L-Tirozinin asetillenmiş formu.', crop: { img: 'assets/pages/lionsmane/4.png', x: 0.75, y: 0.63, f: 0.42 } } } },
    { q: "Neden bazı Lion's Mane ürünlerinde 500 mg, bazılarında 1000 mg yazar?",
      paras: [
        "Lion's Mane ürünlerinde yazan miktar, üreticinin tercih ettiği formülasyona göre değişebilir.",
        'İçerik tablosunda belirtilen değer, ürünün bir serviste sunduğu miktarı gösterir.',
        'Bu nedenle farklı markalarda farklı miktarlar görmek normaldir.'],
      note: { lead: "GRIMSUPPS CLINICAL LION'S MANE", text: 'her serviste 1000 mg Aslan Yelesi Mantarı Ekstresi, ayrıca N-Asetil L-Tirozin, Fosfatidilserin, L-Theanine, Çinko ve Piperin içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/lionsmane/5.png', x: 0.78, y: 0.42, f: 0.5 }, caption: 'Servis başına miktar formülasyona göre değişir' } },
    { q: "Grimsupps Clinical Lion's Mane içerikleri",
      paras: [
        "GRIMSUPPS CLINICAL LION'S MANE formülü; Aslan Yelesi Mantarı Ekstresi, N-Asetil L-Tirozin, Fosfatidilserin, L-Theanine, Çinko ve Piperin içerir."],
      note: { lead: "GRIMSUPPS CLINICAL LION'S MANE", text: '60 tablet · Advanced Brain Support Formula.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '2 Tablet', perContainer: '30 Servis', unit: '2 Tablet', rows: [
        { n: 'Aslan Yelesi Mantarı Ekstresi', v: '1000 mg', brd: '**' },
        { n: 'N-Asetil L-Tirozin', v: '200 mg', brd: '**' },
        { n: 'Fosfatidilserin', v: '100 mg', brd: '**' },
        { n: 'L-Teanin', v: '100 mg', brd: '**' },
        { n: 'Çinko', v: '15 mg', brd: '%150' },
        { n: 'Piperin', v: '10 mg', brd: '**' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  testo: [
    { q: 'Tribulus nedir?',
      paras: [
        'Tribulus terrestris, dikenli yapıya sahip bir bitkidir.',
        'Geleneksel kullanımı eskiye dayanan bu bitki, takviye ürünlerinde ekstresi formuyla yer alır.'],
      note: { lead: 'GRIMSUPPS CLINICAL TESTO BOOST\u2019TA', text: '3 kapsülde 900 mg Tribulus terrestris ekstresi ve %90 saponin bulunur.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/testo/1.png', x: 0.72, y: 0.45, f: 0.52 }, caption: 'Tribulus terrestris — dikenli yapılı bitki' } },
    { q: 'Saponin oranı neden önemli?',
      paras: [
        'Tribulus bitkisinin en çok incelenen bileşen gruplarından biri saponinlerdir.',
        'Ürünlerde genellikle saponin oranı belirtilir; çünkü bu oran, kullanılan ekstrenin standardını gösterir.'],
      note: { lead: 'GRIMSUPPS CLINICAL TESTO BOOST\u2019TA', text: '3 kapsülde 900 mg standardize Tribulus terrestris ekstresi ve %90 saponin bulunur.' },
      viz: { kind: 'dial', value: '%90', label: 'SAPONİN', sub: 'STANDARDİZE EKSTRE' } },
    { q: 'Tribulus ile maca birlikte kullanılır mı?',
      paras: [
        'Evet. Tribulus ve maca, erkeklere yönelik formüllerde sıklıkla bir arada kullanılan bitkisel içeriklerdendir.',
        'Farklı bitkisel kaynaklardan gelen bu içerikler, çok bileşenli formüllerde birlikte yer alır.'],
      note: { lead: 'GRIMSUPPS CLINICAL TESTO BOOST\u2019TA', text: '3 kapsülde 900 mg Tribulus terrestris ekstresi ve 300 mg maca ekstresi bulunur.' },
      viz: { kind: 'compare', joiner: '+',
        a: { title: 'TRIBULUS EKSTRESİ', caption: '900 mg / 3 kapsül', crop: { img: 'assets/pages/testo/3.png', x: 0.77, y: 0.27, f: 0.42 } },
        b: { title: 'MACA EKSTRESİ', caption: '300 mg / 3 kapsül', crop: { img: 'assets/pages/testo/3.png', x: 0.72, y: 0.63, f: 0.42 } } } },
    { q: 'Bitki ekstresi ile bitki tozu aynı şey mi?',
      paras: [
        'Hayır. Bitki tozu, bitkinin kurutulup öğütülmüş hâlidir.',
        'Bitki ekstresi ise bitkinin belirli bileşenlerinin özel işlemlerle yoğunlaştırılmasıyla elde edilir.',
        'Bu nedenle ekstre formu, takviye ürünlerinde daha çok tercih edilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL TESTO BOOST\u2019TA', text: 'Tribulus, maca, Kore ginsengi, saw palmetto ve ginkgo biloba ekstreleri bulunur.' },
      viz: { kind: 'compare', joiner: 'VS',
        a: { title: 'BİTKİ TOZU', caption: 'Kurutulup öğütülmüş bitki.', crop: { img: 'assets/pages/testo/4.png', x: 0.72, y: 0.28, f: 0.4 } },
        b: { title: 'BİTKİ EKSTRESİ', caption: 'Belirli bileşenlerin yoğunlaştırılmış hâli.', crop: { img: 'assets/pages/testo/4.png', x: 0.72, y: 0.72, f: 0.4 } } } },
    { q: 'Bir bitkinin sadece kökü mü kullanılır, tamamı mı?',
      paras: [
        'Bitkiden bitkiye değişir.',
        'Bazı bitkilerde kök, bazılarında meyve, bazılarında ise tüm bitki kullanılır.',
        'Takviye ürünlerinde kullanılan kısım, bitkinin yapısına ve ekstre yöntemine göre belirlenir.'],
      note: { lead: 'GRIMSUPPS CLINICAL TESTO BOOST\u2019TA', text: 'Maca ve Kore ginsengi kökü, saw palmetto meyvesi ve ginkgo biloba yaprağı ekstreleri bulunur.' },
      viz: { kind: 'points',
        items: [
          { t: 'MACA KÖKÜ', s: 'Kökü kullanılır.', crop: { img: 'assets/pages/testo/5.png', x: 0.70, y: 0.20, f: 0.24 } },
          { t: 'KORE GİNSENGİ KÖKÜ', s: 'Kökü kullanılır.', crop: { img: 'assets/pages/testo/5.png', x: 0.655, y: 0.37, f: 0.24 } },
          { t: 'SAW PALMETTO MEYVESİ', s: 'Meyvesi kullanılır.', crop: { img: 'assets/pages/testo/5.png', x: 0.66, y: 0.53, f: 0.24 } },
          { t: 'GİNKGO BİLOBA YAPRAĞI', s: 'Yaprağı kullanılır.', crop: { img: 'assets/pages/testo/5.png', x: 0.67, y: 0.695, f: 0.24 } }] } },
    { q: 'Üç kapsülde on bir bileşen',
      paras: [
        '3 kapsülde 11 farklı bileşen; bitkisel ekstreler, L-arjinin, vitaminler ve mineraller bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL TESTO BOOST', text: 'Clinical Strength Tribulus Apex · 90 kapsül.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '3 Kapsül', perContainer: '30 Servis', unit: '3 Kapsül', rows: [
        { n: 'Demir Dikeni Ekstresi (Tribulus)', v: '900 mg', brd: '**' },
        { n: 'Lepidyum Ekstresi (Maca)', v: '300 mg', brd: '**' },
        { n: 'L-Arjinin', v: '300 mg', brd: '**' },
        { n: 'C Vitamini', v: '240 mg', brd: '%300' },
        { n: 'Kore Ginsengi Ekstresi', v: '150 mg', brd: '**' },
        { n: 'Cüce Palmiye Ekstresi', v: '150 mg', brd: '**' },
        { n: 'Mabet Ağacı Yaprağı Ekstresi', v: '60 mg', brd: '**' },
        { n: 'Koenzim Q10', v: '30 mg', brd: '**' },
        { n: 'Çinko Glukonat', v: '15 mg', brd: '%150' },
        { n: 'B6 Vitamini', v: '4,5 mg', brd: '%321' },
        { n: 'Selenyum', v: '55,2 mcg', brd: '%100' },
        { n: 'D3 Vitamini', v: '22,5 mcg', brd: '%450' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  dim: [
    { q: 'DIM Brokoliden mi elde edilir?',
      paras: [
        'Evet.',
        'DIM, brokoli, karnabahar, lahana ve Brüksel lahanası gibi turpgil sebzelerde bulunan doğal bileşenlerin sindirimi sırasında oluşan bir maddedir.',
        'Takviye ürünlerinde ise saflaştırılmış DIM kullanılır.'],
      note: { lead: 'GRIMSUPPS CLINICAL DIM\u2019DE', text: 'her tablette 200 mg DIM ve 100 mg brokoli ekstresi bulunur.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/dim/1.png', x: 0.72, y: 0.42, f: 0.52 }, caption: 'Turpgil sebzeler — DIM\u2019in doğal kaynağı' } },
    { q: 'DIM doğal mı, sentetik mi?',
      paras: [
        'DIM doğada turpgil sebzelerle ilişkilendirilen doğal bir bileşendir.',
        'Takviye ürünlerinde ise her serviste aynı miktarı sunabilmek için standardize edilmiş DIM ham maddesi kullanılır.'],
      note: { lead: 'GRIMSUPPS CLINICAL DIM\u2019DE', text: 'her tablette 200 mg DIM ve 100 mg brokoli ekstresi bulunur.' },
      viz: { kind: 'flow',
        from: { label: 'TURPGİL SEBZELER', crop: { img: 'assets/pages/dim/2.png', x: 0.78, y: 0.23, f: 0.36 } },
        to: { label: 'STANDARDİZE DIM', sub: 'HER SERVİSTE AYNI MİKTAR', stat: '200 mg', crop: { img: 'assets/pages/dim/2.png', x: 0.74, y: 0.68, f: 0.36 } } } },
    { q: 'Kalsiyum D-Glukarat ile normal kalsiyum aynı şey mi?',
      paras: [
        'Hayır.',
        'Kalsiyum D-Glukarat, klasik kalsiyum takviyelerinden farklı bir içeriktir.',
        'İsminin başında \u201Ckalsiyum\u201D geçse de amacı ve yapısı, kalsiyum karbonat veya kalsiyum sitrat gibi minerallerden farklıdır.'],
      note: { lead: 'GRIMSUPPS CLINICAL DIM\u2019DE', text: 'formülde 500 mg Kalsiyum D-Glukarat yer alır.' },
      viz: { kind: 'compare', joiner: '≠',
        a: { title: 'KALSİYUM D-GLUKARAT', caption: 'Farklı bir içeriktir.' },
        b: { title: 'NORMAL KALSİYUM', caption: 'Farklı bir mineraldir.' } } },
    { q: 'Turpgiller nedir?',
      paras: [
        'Turpgiller, aynı bitki ailesinde yer alan sebzelerin genel adıdır.',
        'Brokoli, karnabahar, lahana, Brüksel lahanası, roka ve turp bu gruba örnek gösterilebilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL DIM\u2019DE', text: 'formülde yer alan DIM ve brokoli ekstresi, turpgil sebzelerle ilişkilendirilen içeriklerdir.' },
      viz: { kind: 'points',
        items: [
          { t: 'BROKOLİ', crop: { img: 'assets/pages/dim/4.png', x: 0.60, y: 0.21, f: 0.2 } },
          { t: 'KARNABAHAR', crop: { img: 'assets/pages/dim/4.png', x: 0.86, y: 0.21, f: 0.2 } },
          { t: 'LAHANA', crop: { img: 'assets/pages/dim/4.png', x: 0.585, y: 0.44, f: 0.2 } },
          { t: 'BRÜKSEL LAHANASI', crop: { img: 'assets/pages/dim/4.png', x: 0.855, y: 0.44, f: 0.2 } },
          { t: 'ROKA', crop: { img: 'assets/pages/dim/4.png', x: 0.60, y: 0.67, f: 0.2 } },
          { t: 'TURP', crop: { img: 'assets/pages/dim/4.png', x: 0.86, y: 0.665, f: 0.2 } }] } },
    { q: 'İndol-3-Karbinol (I3C) ile DIM aynı şey mi?',
      paras: [
        'Hayır. İndol-3-Karbinol (I3C) ve DIM aynı madde değildir.',
        'I3C, turpgil sebzelerde bulunan doğal bir içeriktir. Sindirim sırasında bu içeriğin bir kısmı DIM\u2019e dönüşebilir.',
        'Bu nedenle iki isim birlikte anılsa da aynı şeyi ifade etmez.'],
      note: { lead: 'GRIMSUPPS CLINICAL DIM\u2019DE', text: 'her tablette 200 mg DIM kullanılmıştır.' },
      viz: { kind: 'flow',
        from: { label: 'I3C', sub: 'İNDOL-3-KARBİNOL' },
        to: { label: 'DIM', sub: 'DİİNDOLİL METAN' }, arrowLabel: 'SİNDİRİM SIRASINDA' } },
    { q: 'Grimsupps Clinic DIM içerikleri',
      paras: [
        'Her tablette 10 farklı bileşen, 200 mg DIM ve 500 mg kalsiyum D-glukarat bulunur.'],
      note: { lead: 'GRIMSUPPS CLINIC DIM\u2019DE', text: 'Advanced Hormonal Balance · 30 tablet.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '1 Tablet', perContainer: '30 Servis', unit: '1 Tablet', rows: [
        { n: 'Kalsiyum D-Glukarat', v: '500 mg', brd: '**' },
        { n: 'Diindolilmetan (DIM)', v: '200 mg', brd: '**' },
        { n: 'Alfa Lipoik Asit', v: '100 mg', brd: '**' },
        { n: 'Yeşil Çay Ekstresi', v: '100 mg', brd: '**' },
        { n: 'Brokoli Ekstresi', v: '100 mg', brd: '**' },
        { n: 'Üzüm Çekirdeği Ekstresi', v: '100 mg', brd: '**' },
        { n: 'Çinko Glukonat', v: '15 mg', brd: '%150' },
        { n: 'B6 Vitamini', v: '10 mg', brd: '%714,3' },
        { n: 'Piperin', v: '5 mg', brd: '**' },
        { n: 'Selenyum', v: '198 µg', brd: '%360' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  bromelain: [
    { q: 'Bromelain hangi besinlerde bulunur?',
      paras: [
        'Bromelain doğal olarak en çok ananas bitkisinde bulunur.',
        'Takviye ürünlerinde ise her kullanımda aynı miktarı sunabilmek için standardize bromelain ekstraktı tercih edilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL BROMELAIN COMPLEX\u2019TE', text: 'standardize bromelain ekstraktı kullanıldı.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/bromelain/1.png', x: 0.72, y: 0.44, f: 0.54 }, caption: 'Ananas — bromelainin doğal kaynağı' } },
    { q: 'Lif nedir?',
      paras: [
        'Lifler, sindirim sisteminde parçalanmadan ilerleyen karbonhidratlardır.',
        'Çözünür ve çözünmeyen olmak üzere iki farklı lif türü bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL BROMELAIN COMPLEX\u2019TE', text: 'yer alan konjak glukomannan, çözünür lif kaynaklarından biridir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/bromelain/2.png', x: 0.73, y: 0.475, f: 0.5 }, caption: 'Konjak kökü ve glukomannan lifi' } },
    { q: 'Enzim ile probiyotik aynı şey mi?',
      paras: [
        'Hayır.',
        'Enzimler besinlerin parçalanmasına yardımcı olan protein yapılardır.',
        'Probiyotikler ise canlı mikroorganizmalardır.',
        'Aynı amaçla kullanılmazlar.'],
      note: { lead: 'GRIMSUPPS CLINICAL BROMELAIN COMPLEX\u2019İN', text: 'içeriğinde probiyotik değil, bromelain enzimi bulunur.' },
      viz: { kind: 'compare', joiner: '≠',
        a: { title: 'ENZİM', caption: 'Besinlerin parçalanmasına yardımcı protein yapılar.', crop: { img: 'assets/pages/bromelain/3.png', x: 0.72, y: 0.30, f: 0.4 } },
        b: { title: 'PROBİYOTİK', caption: 'Canlı mikroorganizmalar.', crop: { img: 'assets/pages/bromelain/3.png', x: 0.74, y: 0.63, f: 0.4 } } } },
    { q: 'Bitki ekstresi ne demek?',
      paras: [
        'Bitki ekstresi, bitkinin belirli bileşenlerinin yoğunlaştırılarak elde edilen formudur.',
        'Bu sayede daha standart ve kontrollü bir içerik hazırlanabilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL BROMELAIN COMPLEX\u2019TE', text: 'Garcinia cambogia, maydanoz ve ananas gibi bitkilerin ekstreleri kullanıldı.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/bromelain/4.png', x: 0.72, y: 0.42, f: 0.5 }, caption: 'Yoğunlaştırılmış bitki ekstresi' } },
    { q: 'Krom pikolinat nedir?',
      paras: [
        'Krom pikolinat, krom mineralinin pikolinik asitle birleşmiş formudur.',
        'Takviye ürünlerinde en sık kullanılan krom formlarından biridir.'],
      note: { lead: 'GRIMSUPPS CLINICAL BROMELAIN COMPLEX\u2019TE', text: '200 mcg krom pikolinat yer alır.' },
      viz: { kind: 'flow',
        from: { label: 'KROM (Cr)', crop: { img: 'assets/pages/bromelain/5.png', x: 0.79, y: 0.28, f: 0.24 } },
        to: { label: 'KROM PİKOLİNAT', sub: 'PİKOLİNİK ASİTLE BİRLEŞMİŞ FORM', stat: '200 mcg' } } },
    { q: 'Glukomannan hangi bitkiden elde edilir?',
      paras: [
        'Glukomannan, Asya kökenli konjak bitkisinin kökünden elde edilen doğal bir çözünür liftir.'],
      note: { lead: 'GRIMSUPPS CLINICAL BROMELAIN COMPLEX\u2019TE', text: 'konjak glukomannan tercih edildi.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/bromelain/6.png', x: 0.74, y: 0.55, f: 0.5 }, caption: 'Konjak bitkisi ve kökü' } },
    { q: 'Bromelain Complex\u2019te hangi bileşenler bulunur?',
      paras: [
        'GRIMSUPPS CLINICAL BROMELAIN COMPLEX\u2019te tek tablette 8 farklı bileşen bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL BROMELAIN COMPLEX', text: 'Digestive & Metabolic Support · 60 kapsül.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '1 Kapsül', perContainer: '60 Servis', unit: '1 Kapsül', rows: [
        { n: 'Bromelain', v: '500 mg', brd: '**' },
        { n: 'Konjak Glukomannan', v: '250 mg', brd: '**' },
        { n: 'Vitamin C', v: '30 mg', brd: '%38' },
        { n: 'Ananas Ekstresi', v: '20 mg', brd: '**' },
        { n: 'Garcinia Ekstresi', v: '20 mg', brd: '**' },
        { n: 'Maydanoz Ekstresi', v: '10 mg', brd: '**' },
        { n: 'Kuersetin', v: '10 mg', brd: '**' },
        { n: 'Koenzim Q10', v: '2 mg', brd: '**' },
        { n: 'Çinko', v: '2 mg', brd: '%20' },
        { n: 'Krom', v: '60 µg', brd: '%150' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  d3k2: [
    { q: 'D3 vitamini hangi besinlerde bulunur?',
      paras: [
        'D3 vitamini doğal olarak en çok yağlı balıklar, yumurta sarısı ve karaciğer gibi hayvansal besinlerde bulunur.',
        'Ayrıca güneş ışığının etkisiyle ciltte de üretilebilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL D3+K2 CORE PLATINIUM\u2019DA', text: 'her softgelde 25 mcg (1000 IU) D3 vitamini bulunur.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/d3k2/1.png', x: 0.72, y: 0.42, f: 0.5 }, caption: 'Yağlı balıklar, yumurta sarısı, karaciğer — ve güneş ışığı' } },
    { q: 'D3 vitamini neden hem IU hem mcg olarak yazılır?',
      paras: [
        'D3 vitamini iki farklı ölçü birimiyle ifade edilebilir.',
        'IU (Uluslararası Birim) biyolojik aktiviteyi gösterir; mcg (mikrogram) ağırlık miktarını gösterir.',
        'Bu nedenle birçok D3 ürününde iki değer birlikte yer alır.'],
      note: { lead: 'GRIMSUPPS CLINICAL D3+K2 CORE PLATINIUM\u2019DA', text: 'her softgelde 25 mcg (1000 IU) D3 vitamini bulunur.' },
      viz: { kind: 'compare', joiner: '=',
        a: { title: 'IU', caption: 'Uluslararası Birim — biyolojik aktiviteyi gösterir.' },
        b: { title: 'MCG', caption: 'Mikrogram — ağırlık miktarını gösterir.' } } },
    { q: 'Koenzim Q10 hangi besinlerde bulunur?',
      paras: [
        'Koenzim Q10; kırmızı et, balık, sakatat ve bazı kuruyemişlerde doğal olarak bulunur.',
        'Takviye ürünlerinde ise her serviste standart miktar sunabilmek amacıyla ayrıca eklenebilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL D3+K2 CORE PLATINIUM\u2019DA', text: 'her softgelde 10 mg Koenzim Q10 bulunur.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/d3k2/3.png', x: 0.72, y: 0.45, f: 0.52 }, caption: 'Kırmızı et, balık, sakatat ve kuruyemişler' } },
    { q: 'K2 vitamini hangi besinlerde bulunur?',
      paras: [
        'K2 vitamini en çok fermente gıdalarda bulunur.',
        'Natto, bazı olgunlaştırılmış peynirler ve fermente süt ürünleri doğal K2 kaynakları arasında yer alır.'],
      note: { lead: 'GRIMSUPPS CLINICAL D3+K2 CORE PLATINIUM\u2019DA', text: 'her softgelde 11,25 mcg K2 vitamini bulunur.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/d3k2/4.png', x: 0.73, y: 0.44, f: 0.52 }, caption: 'Natto, olgunlaştırılmış peynir, fermente süt ürünleri' } },
    { q: 'MK-7 nedir?',
      paras: [
        'MK-7, K2 vitamininin en yaygın kullanılan formlarından biridir.',
        'Takviye ürünlerinde K2 vitamini genellikle MK-4 veya MK-7 formunda bulunur.',
        'Bu nedenle ürün etiketlerinde hangi formun kullanıldığı ayrıca belirtilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL D3+K2 CORE PLATINIUM\u2019DA', text: 'her softgelde 11,25 mcg K2 vitamini (MK-7) bulunur.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/d3k2/5.png', x: 0.68, y: 0.42, f: 0.52 }, caption: 'MK-7 — K2 vitamininin yaygın formu' } },
    { q: 'D3+K2 Core Platinium içerikleri',
      paras: [
        'Her softgelde 25 mcg (1000 IU) D3 vitamini, 11,25 mcg K2 vitamini (MK-7) ve 10 mg Koenzim Q10 bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL D3+K2 CORE PLATINIUM', text: 'Next Generation D3K2 Formula · 60 softgel.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '1 Softjel', perContainer: '60 Servis', unit: '1 Softjel', rows: [
        { n: 'Koenzim Q10', v: '10 mg', brd: '**' },
        { n: 'Vitamin D3', v: '25 mcg', brd: '%500' },
        { n: 'Vitamin K2 (MK-7)', v: '11,25 mcg', brd: '%15' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  glucosamine: [
    { q: 'Glukozamin nedir?',
      paras: [
        'Glukozamin, vücutta doğal olarak bulunan bir amino şeker türüdür.',
        'Takviye ürünlerinde genellikle eklem yapısında yer alan bileşenlerden biridir.'],
      note: { lead: 'GRIMSUPPS CLINICAL GLUCOSAMINE', text: 'her serviste 1500 mg glukozamin sülfat içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/glucosamine/1.png', x: 0.72, y: 0.42, f: 0.52 }, caption: 'Glukozamin — amino şeker molekülü' } },
    { q: 'Glukozamin hangi besinlerde bulunur?',
      paras: [
        'Doğal olarak en çok kabuklu deniz canlılarının kabuk yapısında bulunur.',
        'Günlük beslenmede anlamlı miktarlarda alınabilecek bir kaynak değildir.'],
      note: { lead: 'GRIMSUPPS CLINICAL GLUCOSAMINE', text: 'deniz kaynaklı glukozamin sülfat; kondroitin, MSM ve bitki ekstreleriyle bir araya getirilmiştir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/glucosamine/2.png', x: 0.74, y: 0.42, f: 0.52 }, caption: 'Kabuklu deniz canlıları — glukozaminin doğal kaynağı' } },
    { q: 'Glukozamin vücutta doğal olarak bulunur mu?',
      paras: [
        'Evet. Glukozamin insan vücudunda doğal olarak bulunan bir bileşendir.',
        'Vücutta üretilebildiği kadar, dışarıdan da alınması mümkündür.'],
      note: { lead: 'GRIMSUPPS CLINICAL GLUCOSAMINE', text: 'vücutta doğal olarak bulunan glukozamini takviye formunda sunar.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/glucosamine/3.png', x: 0.80, y: 0.38, f: 0.5 }, caption: 'Eklem yapısı — glukozaminin vücuttaki yeri' } },
    { q: 'Glukozamin neden takviye olarak üretilir?',
      paras: [
        'Günlük beslenmeyle glukozamin ihtiyacını karşılayacak miktarlara ulaşmak zordur.',
        'Bu nedenle takviye ürünlerinde konsantre formda yer alır.'],
      note: { lead: 'GRIMSUPPS CLINICAL GLUCOSAMINE', text: 'her serviste 1500 mg glukozamin sülfat içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/glucosamine/4.png', x: 0.74, y: 0.50, f: 0.5 }, caption: 'Konsantre form — takviye ürünü' } },
    { q: 'Tek bileşenli glukozamin ile kompleks formüller arasındaki fark nedir?',
      paras: [
        'Tek bileşenli ürünlerde yalnızca glukozamin bulunur.',
        'Kompleks formüllerde ise glukozamine ek olarak kondroitin, MSM, bitki ekstreleri ve farklı bileşenler yer alır.'],
      note: { lead: 'GRIMSUPPS CLINICAL GLUCOSAMINE', text: 'glukozaminin yanında kondroitin, MSM, akgünlük ve zerdeçal ekstresi de içerir.' },
      viz: { kind: 'compare', joiner: 'VS',
        a: { title: 'TEK BİLEŞENLİ', caption: 'Yalnızca glukozamin bulunur.', crop: { img: 'assets/pages/glucosamine/5.png', x: 0.73, y: 0.33, f: 0.30 } },
        b: { title: 'KOMPLEKS FORMÜL', caption: 'Glukozamin + kondroitin + MSM + bitki ekstreleri.', crop: { img: 'assets/pages/glucosamine/5.png', x: 0.72, y: 0.53, f: 0.32 } } } },
    { q: 'Bir serviste neden 5 farklı bileşen var?',
      paras: [
        'Takviye ürünleri tek bileşenli veya çok bileşenli olarak hazırlanabilir.',
        'Çok bileşenli formüllerde farklı bileşenler tek serviste bir araya getirilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL GLUCOSAMINE', text: 'glukozamini temel alan; kondroitin, MSM, akgünlük ve zerdeçal ekstrelerinden oluşan çok bileşenli bir formüldür.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '2 Tablet', perContainer: '30 Servis', unit: '2 Tablet', rows: [
        { n: 'Glikozamin Sülfat', v: '1500 mg', brd: '**' },
        { n: 'Kondroitin Sülfat', v: '150 mg', brd: '**' },
        { n: 'Metilsülfonilmetan (MSM)', v: '150 mg', brd: '**' },
        { n: 'Akgünlük Ekstresi (Boswellia)', v: '150 mg', brd: '**' },
        { n: 'Zerdeçal Ekstresi (Turmeric)', v: '100 mg', brd: '%150' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  multi: [
    { q: 'Multivitaminlerde neden bu kadar çok bileşen bulunur?',
      paras: [
        'Vitamin ve mineraller vücutta farklı görevleri yerine getirir.',
        'Bu nedenle multivitaminlerde tek bir bileşen yerine birçok vitamin ve mineral bir araya getirilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL MULTIVIT\u2019TE', text: '28 farklı vitamin, mineral ve bitkisel bileşen bulunur.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/multi/1.png', x: 0.72, y: 0.44, f: 0.55 }, caption: 'Tek kapsülde bir araya gelen bileşenler' } },
    { q: 'Multivitaminlerde neden hem vitamin hem mineral bulunur?',
      paras: [
        'Vitaminler ve mineraller aynı şey değildir.',
        'Farklı gruplara ait bu bileşenler, multivitamin formüllerinde birlikte yer alır.'],
      note: { lead: 'GRIMSUPPS CLINICAL MULTIVIT', text: 'vitaminleri ve mineralleri tek formülde bir araya getirir.' },
      viz: { kind: 'compare', joiner: '+',
        a: { title: 'VİTAMİNLER', caption: 'Bitkisel ve hayvansal kaynaklardan.', crop: { img: 'assets/pages/multi/2.png', x: 0.75, y: 0.27, f: 0.34 } },
        b: { title: 'MİNERALLER', caption: 'İnorganik kaynaklardan.', crop: { img: 'assets/pages/multi/2.png', x: 0.74, y: 0.60, f: 0.34 } } } },
    { q: 'BRD yüzdesi neyi gösterir?',
      paras: [
        'BRD, Bir Günlük Referans Değer anlamına gelir.',
        'Etikette yer alan yüzde değerler, bir servisin günlük referans alım miktarının ne kadarını karşıladığını gösterir.'],
      note: { lead: 'GRIMSUPPS CLINICAL MULTIVIT\u2019İN', text: 'etiketinde her bileşenin BRD yüzdesi ayrı ayrı belirtilir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/multi/3.png', x: 0.72, y: 0.42, f: 0.55 }, caption: 'BRD % — Bir Günlük Referans Değer' } },
    { q: 'Multivitamin alırken etikette ilk neye bakılmalıdır?',
      paras: [
        'İlk olarak içerik listesine bakılmalıdır.',
        'Hangi vitamin ve minerallerin bulunduğu, miktarları ve kullanılan formlar etiket üzerinde yer alır.'],
      note: { lead: 'GRIMSUPPS CLINICAL MULTIVIT\u2019İN', text: 'etiketinde tüm bileşenler ve miktarları açıkça yer alır.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/multi/4.png', x: 0.72, y: 0.40, f: 0.55 }, caption: 'İçerik listesi — miktarlar ve formlar' } },
    { q: 'Vücut fazla aldığı vitaminleri depolar mı?',
      paras: [
        'Her vitamin aynı şekilde depolanmaz.',
        'Yağda çözünen vitaminler ile suda çözünen vitaminlerin vücuttaki depolanma şekilleri farklıdır.'],
      note: { lead: 'GRIMSUPPS CLINICAL MULTIVIT', text: 'yağda ve suda çözünen vitaminleri aynı formülde buluşturur.' },
      viz: { kind: 'compare', joiner: 'VS',
        a: { title: 'YAĞDA ÇÖZÜNENLER', caption: 'A, D, E, K', crop: { img: 'assets/pages/multi/5.png', x: 0.73, y: 0.31, f: 0.36 } },
        b: { title: 'SUDA ÇÖZÜNENLER', caption: 'B GRUBU, C', crop: { img: 'assets/pages/multi/5.png', x: 0.76, y: 0.60, f: 0.36 } } } },
    { q: 'Grimsupps Clinical Multivit içerikleri',
      paras: [
        'GRIMSUPPS CLINICAL MULTIVIT\u2019TE 13 vitamin, 9 mineral, 3 bitki ekstresi ve 3 diğer bileşen bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL MULTIVIT', text: 'Advanced Multivitamin · 60 kapsül.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '1 Kapsül', perContainer: '60 Servis', unit: '1 Kapsül', rows: [
        { n: 'Kalsiyum', v: '120 mg', brd: '%15' },
        { n: 'Vitamin C', v: '200 mg', brd: '%250' },
        { n: 'Magnezyum', v: '60 mg', brd: '%16' },
        { n: 'Fosfatidilserin', v: '40 mg', brd: '**' },
        { n: 'L-Arjinin', v: '40 mg', brd: '**' },
        { n: 'L-Lizin', v: '40 mg', brd: '**' },
        { n: 'Kore Ginsengi Ekstresi', v: '40 mg', brd: '**' },
        { n: 'Yeşil Çay Ekstresi', v: '40 mg', brd: '**' },
        { n: 'Ginkgo Ekstresi', v: '40 mg', brd: '**' },
        { n: 'Koenzim Q10', v: '20 mg', brd: '**' },
        { n: 'Vitamin B3', v: '16 mg', brd: '%100' },
        { n: 'Çinko', v: '15 mg', brd: '%150' },
        { n: 'Demir', v: '14 mg', brd: '%100' },
        { n: 'Vitamin E', v: '12 mg', brd: '%100' },
        { n: 'Vitamin B6', v: '10 mg', brd: '%714' },
        { n: 'Vitamin B5', v: '6 mg', brd: '%100' },
        { n: 'Manganez', v: '2 mg', brd: '%100' },
        { n: 'Vitamin B2', v: '1,4 mg', brd: '%100' },
        { n: 'Vitamin B1', v: '1,1 mg', brd: '%100' },
        { n: 'Bakır', v: '2000 µg', brd: '%200' },
        { n: 'Biotin', v: '1000 µg', brd: '%2000' },
        { n: 'Vitamin A', v: '800 µg RE', brd: '%100' },
        { n: 'Selenyum', v: '200 µg', brd: '%364' },
        { n: 'Folik Asit', v: '400 µg', brd: '%200' },
        { n: 'İyot', v: '150 µg', brd: '%100' },
        { n: 'Vitamin K2', v: '80 µg', brd: '%107' },
        { n: 'Vitamin B12', v: '20 µg', brd: '%800' },
        { n: 'Vitamin D3', v: '10 µg', brd: '%200' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  vitac: [
    { q: 'C vitamini ile ascorbic acid aynı şey mi?',
      paras: [
        'Evet. Ascorbic acid, C vitamininin kimyasal adıdır.',
        'Takviye ürünlerinde her iki isim de aynı bileşeni ifade eder.'],
      note: { lead: 'GRIMSUPPS CLINICAL VITA-C PLUS\u2019TA', text: 'C vitamini kaynağı olarak askorbik asit kullanılmıştır.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/vitac/1.png', x: 0.72, y: 0.42, f: 0.5 }, caption: 'Askorbik asit — C vitamininin kimyasal adı' } },
    { q: 'Fazla alınan C vitamini ne olur?',
      paras: [
        'C vitamini suda çözünen bir vitamindir.',
        'Vücutta ihtiyaç fazlası idrar yoluyla atılır.',
        'Aşırı yüksek dozlarda bazı kişilerde mide rahatsızlıklarına ve bağırsak hareketlerinde artışa neden olabilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL VITA-C PLUS', text: 'her tablette 400 mg C vitamini (Askorbik Asit) içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/vitac/2.png', x: 0.72, y: 0.45, f: 0.5 }, caption: 'Suda çözünen vitamin — fazlası idrarla atılır' } },
    { q: 'C vitamini neden turunçgillerle özdeşleşmiş?',
      paras: [
        'Çünkü turunçgiller, C vitamini açısından zengin meyvelerdir ve tarih boyunca en kolay erişilebilen doğal kaynaklardan biri olmuştur.',
        'Bu yüzden C vitamini denildiğinde akla ilk olarak portakal ve limon gibi meyveler gelir.'],
      note: { lead: 'GRIMSUPPS CLINICAL VITA-C PLUS\u2019TA', text: 'C vitaminine ek olarak kara mürver ekstresi, resveratrol ve kuersetin de yer alır.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/vitac/3.png', x: 0.71, y: 0.31, f: 0.5 }, caption: 'Turunçgiller — C vitamininin bilinen doğal kaynağı' } },
    { q: 'C vitamini neden hayvanlar tarafından üretilebilirken insanlar üretemiyor?',
      paras: [
        'Çoğu hayvanın vücudu C vitaminini kendi başına üretebilir.',
        'İnsanlarda ise bu üretim sürecinde görev alan L-gulonolakton oksidaz enzimi eksiktir.',
        'Bu nedenle insanlar C vitaminini besinlerden veya takviyelerden almak zorundadır.'],
      note: { lead: 'GRIMSUPPS CLINICAL VITA-C PLUS', text: 'her tablette 400 mg C vitamini içerir.' },
      viz: { kind: 'compare', joiner: 'VS',
        a: { title: 'HAYVANLAR', caption: 'C vitaminini kendi vücudunda üretebilir.', crop: { img: 'assets/pages/vitac/4.png', x: 0.83, y: 0.235, f: 0.30 } },
        b: { title: 'İNSANLAR', caption: 'L-gulonolakton oksidaz enzimi eksiktir.', crop: { img: 'assets/pages/vitac/4.png', x: 0.83, y: 0.53, f: 0.30 } } } },
    { q: 'C vitamini neden bazı markalarda tek başına kullanılmıyor?',
      paras: [
        'Çünkü C vitamini, bazı bileşenlerle birlikte kullanıldığında daha kapsamlı formüller oluşturulabilir.',
        'Bu yüzden bazı markalar, C vitaminini bitki ekstreleri, mineraller ve diğer aktif bileşenlerle bir araya getirerek formüle eder.'],
      note: { lead: 'GRIMSUPPS CLINICAL VITA-C PLUS', text: 'C vitamininin yanında beta glukan, kara mürver ekstresi, resveratrol, kuersetin, Koenzim Q10, Kore ginsengi ekstresi, çinko ve D3 vitamini içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/vitac/5.png', x: 0.74, y: 0.36, f: 0.5 }, caption: 'C vitamini + destekleyici bileşenler — kapsamlı formül' } },
    { q: 'Vita-C Plus\u2019ta hangi bileşenler bulunur?',
      paras: [
        'GRIMSUPPS CLINICAL VITA-C PLUS\u2019ta C vitaminiyle birlikte 8 destekleyici bileşen bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL VITA-C PLUS', text: '9-in-1 Daily Protect · 60 kapsül.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '1 Kapsül', perContainer: '60 Servis', unit: '1 Kapsül', rows: [
        { n: 'C Vitamini (Askorbik Asit)', v: '400 mg', brd: '%500' },
        { n: 'Kara Mürver Ekstresi', v: '100 mg', brd: '**' },
        { n: 'Kore Ginsengi Ekstresi', v: '100 mg', brd: '**' },
        { n: 'Resveratrol', v: '40 mg', brd: '**' },
        { n: 'Beta Glukan (arpa/yulaf kaynaklı)', v: '40 mg', brd: '**' },
        { n: 'Koenzim Q10', v: '40 mg', brd: '**' },
        { n: 'Kuersetin', v: '40 mg', brd: '**' },
        { n: 'Çinko Glukonat', v: '15 mg', brd: '%150' },
        { n: 'D3 Vitamini', v: '10 µg', brd: '%200' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  berberine: [
    { q: 'Berberine nedir?',
      paras: [
        'Berberine, Berberis vulgaris başta olmak üzere bazı bitkilerden elde edilen doğal bir bileşendir.',
        'Takviye ürünlerinde genellikle standardize ekstrakt formu kullanılır.'],
      note: { lead: 'GRIMSUPPS CLINICAL BERBERINE FORTE\u2019DE', text: 'her serviste 1000 mg Berberis vulgaris ekstresi bulunur.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/berberine/1.png', x: 0.77, y: 0.44, f: 0.5 }, caption: 'Berberis vulgaris — berberine\u2019in doğal kaynağı' } },
    { q: 'Berberine hangi besinlerde bulunur?',
      paras: [
        'Berberine, günlük beslenmede tüketilen meyve ve sebzelerde bulunan bir bileşen değildir.',
        'Doğal olarak berberis türü bitkilerin kök, gövde ve kabuk kısımlarında bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL BERBERINE FORTE\u2019DE', text: 'berberine kaynağı olarak Berberis vulgaris ekstresi kullanılmıştır.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/berberine/2.png', x: 0.78, y: 0.46, f: 0.5 }, caption: 'Kök, gövde ve kabuk — berberine\u2019in bulunduğu kısımlar' } },
    { q: 'Berberine ile Berberis vulgaris aynı şey mi?',
      paras: [
        'Hayır. Berberis vulgaris bitkinin adıdır.',
        'Berberine ise bu bitkiden elde edilen doğal bileşenlerden biridir.'],
      note: { lead: 'GRIMSUPPS CLINICAL BERBERINE FORTE', text: 'Berberis vulgaris ekstresi içeren bir formülle hazırlanmıştır.' },
      viz: { kind: 'compare', joiner: '→',
        a: { title: 'BERBERIS VULGARIS', caption: 'Bitkinin adı.', crop: { img: 'assets/pages/berberine/3.png', x: 0.79, y: 0.32, f: 0.34 } },
        b: { title: 'BERBERINE', caption: 'Bitkiden elde edilen bileşen.', crop: { img: 'assets/pages/berberine/3.png', x: 0.62, y: 0.66, f: 0.34 } } } },
    { q: 'Her bitki ekstresi aynı yoğunlukta mıdır?',
      paras: [
        'Hayır. Bitki ekstreleri kullanılan ham maddeye, ekstraksiyon yöntemine ve standardizasyon oranına göre farklı yoğunluklarda olabilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL BERBERINE FORTE\u2019DE', text: 'standardize bitki ekstreleri tercih edilmiştir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/berberine/4.png', x: 0.74, y: 0.42, f: 0.5 }, caption: 'Aynı bitki, farklı yoğunluk — ekstraksiyon belirleyicidir' } },
    { q: 'Etikette ekstrakt oranı neyi ifade eder?',
      paras: [
        'Ekstrakt oranı, bitkinin ne kadar yoğunlaştırıldığını gösterir.',
        'Örneğin 10:1 ekstrakt ifadesi, 10 birim bitkiden 1 birim ekstrakt elde edildiğini belirtir.'],
      note: { lead: 'GRIMSUPPS CLINICAL BERBERINE FORTE\u2019DE', text: 'kullanılan bileşenler ve miktarları açık şekilde belirtilmiştir.' },
      viz: { kind: 'compare', joiner: '→',
        a: { title: '10 BİRİM BİTKİ', caption: 'Ham bitki materyali.', crop: { img: 'assets/pages/berberine/5.png', x: 0.75, y: 0.33, f: 0.34 } },
        b: { title: '1 BİRİM EKSTRAKT', caption: 'Yoğunlaştırılmış ekstrakt.', crop: { img: 'assets/pages/berberine/5.png', x: 0.68, y: 0.66, f: 0.34 } } } },
    { q: 'Berberine Forte\u2019de hangi bileşenler bulunur?',
      paras: [
        'GRIMSUPPS CLINICAL BERBERINE FORTE\u2019de her serviste 7 farklı bileşen ve 1000 mg Berberis vulgaris ekstresi bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL BERBERINE FORTE', text: 'Glucose & Insulin Support · 60 tablet.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '2 Tablet', perContainer: '30 Servis', unit: '2 Tablet', rows: [
        { n: 'Berberis Vulgaris (Karamuk) Ekstresi', v: '1000 mg', brd: '**' },
        { n: 'Alfa Lipoik Asit', v: '200 mg', brd: '**' },
        { n: 'Fosfatidilkolin', v: '100 mg', brd: '**' },
        { n: 'İnülin', v: '100 mg', brd: '**' },
        { n: 'Çinko Glukonat', v: '15 mg', brd: '%10' },
        { n: 'Piperin', v: '10 mg', brd: '**' },
        { n: 'Krom Pikolinat', v: '3,26 mg', brd: '%487' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  hmb: [
    { q: 'HMB nedir?',
      paras: [
        'HMB, Beta-Hidroksi Beta-Metilbütirat adlı bir bileşendir.',
        'Vücutta lösin amino asidinin metabolizması sonucu oluşur.'],
      note: { lead: 'GRIMSUPPS CLINICAL HMB,', text: 'her serviste 3000 mg HMB içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/hmb/1.png', x: 0.69, y: 0.41, f: 0.55 }, caption: 'Beta-Hidroksi Beta-Metilbütirat' } },
    { q: 'HMB hangi besinlerde bulunur?',
      paras: [
        'HMB, özellikle et, tavuk, balık ve süt ürünlerinde düşük miktarlarda bulunur.',
        'Günlük beslenmeyle alınan miktar genellikle oldukça sınırlıdır.'],
      note: { lead: 'GRIMSUPPS CLINICAL HMB,', text: 'her serviste 3000 mg HMB ile beslenmeyle alınan miktarın çok üzerindedir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/hmb/2.png', x: 0.69, y: 0.46, f: 0.55 }, caption: 'Et, tavuk, balık, süt ürünleri' } },
    { q: 'HMB neden lösin ile ilişkilidir?',
      paras: [
        'HMB, vücutta lösin amino asidinin metabolizması sırasında oluşan bir bileşendir.',
        'Lösin, proteinlerde doğal olarak bulunan esansiyel bir amino asittir.'],
      note: { lead: 'GRIMSUPPS CLINICAL HMB,', text: 'lösinden oluşan doğal bir metabolit olduğundan proteinlerle ilişkilidir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/hmb/3.png', x: 0.73, y: 0.43, f: 0.55 }, caption: 'Lösin → HMB' } },
    { q: 'HMB\u2019yi sadece sporcular mı kullanır?',
      paras: [
        'HMB kullanımı sporcularla sınırlı değildir.',
        'Düzenli beslenen, hızlı yaşayan veya protein alımına dikkat eden herkes tarafından kullanılabilir.'],
      note: { lead: 'GRIMSUPPS CLINICAL HMB,', text: 'günlük kullanıma uygun tablet formundadır.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/hmb/4.png', x: 0.71, y: 0.44, f: 0.55 }, caption: 'Sadece sporcular için değil' } },
    { q: 'HMB tek başına kullanılır mı?',
      paras: [
        'Evet. HMB, tek başına kullanılabilen bir bileşendir.',
        'Ancak birçok formülde magnezyum, çinko ve B6 vitamini gibi besin öğeleri ile birlikte yer alır.'],
      note: { lead: 'GRIMSUPPS CLINICAL HMB,', text: 'magnezyum, çinko ve B6 vitamini ile birlikte formüle edilmiştir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/hmb/5.png', x: 0.73, y: 0.49, f: 0.55 }, caption: 'HMB + magnezyum + çinko + B6' } },
    { q: 'HMB Muscle Support\u2019ta hangi bileşenler bulunur?',
      paras: [
        'GRIMSUPPS CLINICAL HMB, her serviste 3000 mg HMB dahil 4 bileşen sunar: magnezyum, çinko ve vitamin B6.'],
      note: { lead: 'GRIMSUPPS CLINICAL HMB,', text: '4 bileşen · 90 tablet.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '3 Tablet', perContainer: '30 Servis', unit: '3 Tablet', rows: [
        { n: 'HMB (Beta-Hidroksi Beta-Metilbütirat)', v: '3000 mg', brd: '**' },
        { n: 'Magnezyum', v: '150 mg', brd: '%40' },
        { n: 'Çinko', v: '15 mg', brd: '%150' },
        { n: 'Vitamin B6', v: '9 mg', brd: '%643' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ],
  b12: [
    { q: 'B12 vitamini vücutta üretilebilir mi?',
      paras: [
        'Hayır. İnsan vücudu B12 vitamini üretemez.',
        'Bu nedenle B12, besinlerden veya takviye ürünlerinden alınması gereken vitaminlerden biridir.'],
      note: { lead: 'GRIMSUPPS CLINICAL B12++,', text: 'her tablette 1000 mcg B12 içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/b12/1.png', x: 0.75, y: 0.40, f: 0.52 }, caption: 'Vücut B12 üretemez — dışarıdan alınması gerekir' } },
    { q: 'B12 neden mikrogram (mcg) ile ölçülür?',
      paras: [
        'B12, çok küçük miktarlarda kullanılan vitaminlerden biridir.',
        'Bu nedenle etiketlerde genellikle miligram (mg) yerine mikrogram (mcg) birimi kullanılır.'],
      note: { lead: 'CLINICAL B12++ ETİKETİNDE', text: 'B12 miktarı mikrogram (mcg) cinsinden belirtilmiştir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/b12/2.png', x: 0.76, y: 0.40, f: 0.48 }, caption: 'Mikrogram ölçeği — çok küçük miktarlar' } },
    { q: 'Çiğnenebilir tablet neden kullanılır?',
      paras: [
        'Çiğnenebilir tabletler su gerektirmeden kullanılabilir.',
        'Kapsül yutmak istemeyen kullanıcılar için pratik bir alternatif sunar.',
        'Ağızda kolayca çiğnenir ve hoş bir tat bırakır.'],
      note: { lead: 'GRIMSUPPS CLINICAL B12\u2019DE', text: 'çilek aromalı çiğnenebilir tablet formunda üretilmiştir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/b12/3.png', x: 0.75, y: 0.42, f: 0.46 }, caption: 'Çilek aromalı çiğnenebilir form' } },
    { q: 'B12 hangi besinlerde bulunur?',
      paras: [
        'B12 vitamini doğal olarak hayvansal kaynaklı besinlerde bulunur.',
        'Kırmızı et, balık, yumurta ve süt ürünleri B12 açısından zengin besinlerdir.'],
      note: { lead: 'GRIMSUPPS CLINICAL B12\u2019DE', text: 'her tablette 1000 mcg B12 ile pratik bir takviye sağlar.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/b12/4.png', x: 0.76, y: 0.41, f: 0.48 }, caption: 'Kırmızı et, balık, yumurta, süt ürünleri' } },
    { q: 'Her B12 ürünü aynı miktarda B12 içerir mi?',
      paras: [
        'Hayır. Ürünlerin içerdiği B12 miktarı markaya ve formüle göre değişebilir.',
        'Bu nedenle etiket üzerindeki B12 miktarını kontrol etmek önemlidir.'],
      note: { lead: 'GRIMSUPPS CLINICAL B12++,', text: 'her tablette 1000 mcg B12 içerir.' },
      viz: { kind: 'crop', crop: { img: 'assets/pages/b12/5.png', x: 0.76, y: 0.37, f: 0.48 }, caption: 'Ürünler arası B12 miktarı değişir — etikete bakın' } },
    { q: 'B12++ Chewable\u2019da hangi bileşenler bulunur?',
      paras: [
        'GRIMSUPPS CLINICAL B12++\u2019da her çiğnenebilir tablette 1000 mcg B12, 500 µg folik asit ve 10 mg vitamin B6 bulunur.'],
      note: { lead: 'GRIMSUPPS CLINICAL B12\u2019DE', text: 'bio-aktif metil formülü ile 3 bileşen · 60 çiğnenebilir tablet.' },
      viz: { kind: 'facts', title: 'İçerik Tablosu · Supplement Facts', serving: '1 Çiğneme Tablet', perContainer: '60 Servis', unit: '1 Çiğneme Tablet', rows: [
        { n: 'Vitamin B12 (Metilkobalamin)', v: '1000 µg', brd: '%40.000' },
        { n: 'Folik Asit', v: '500 µg', brd: '%250' },
        { n: 'Vitamin B6', v: '10 mg', brd: '%714' }
      ], foot: '%BRD: Beslenme Referans Değeri. ** Beslenme referans değeri belirlenmemiştir.' } }
  ]
};
// Hero formula-mode capsule crop (from ingredient diagram page) per product
window.PILL = {
  magnesium: { img: 'assets/pages/magnesium/6.png', x: 0.55, y: 0.46, f: 0.26 }
};

window.STORY_SEQ = {'01':'5htp','1':'5htp','02':'magnesium','2':'magnesium','03':'omega','3':'omega','04':'lionsmane','4':'lionsmane','05':'testo','5':'testo','06':'dim','6':'dim','07':'bromelain','7':'bromelain','08':'d3k2','8':'d3k2','09':'glucosamine','9':'glucosamine','10':'multi','11':'vitac','12':'berberine','13':'b12','14':'hmb'};
